"use client";

import { createContext, useContext } from "react";
import {
  defaultLocale,
  getTextDirection,
  type Locale,
  type TextDirection,
} from "@/lib/i18n/config";

const LocaleContext = createContext<Locale>(defaultLocale);

export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return (
    <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
  );
}

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

export function useTextDirection(): TextDirection {
  return getTextDirection(useLocale());
}
